import React, { useState } from 'react';

const MasrafBildirimFormu = () => {
  const [formData, setFormData] = useState({
    masrafTarihi: '',
    masrafTuru: '',
    tutar: '',
    aciklama: '',
    fatura: null
  });

  const [errors, setErrors] = useState({});

  const masrafTurleri = [
    { value: 'konaklama', label: 'Konaklama' },
    { value: 'ulasim', label: 'Ulaşım' },
    { value: 'yemek', label: 'Yemek' },
    { value: 'yakit', label: 'Yakıt' },
    { value: 'telefon', label: 'Telefon' },
    { value: 'internet', label: 'Internet' },
    { value: 'kirtasiye', label: 'Kırtasiye' },
    { value: 'diger', label: 'Diğer' }
  ];

  const handleInputChange = (e) => {
    const { name, value, type, files } = e.target;
    
    if (type === 'file') {
      setFormData(prev => ({
        ...prev,
        [name]: files[0]
      }));
    } else {
      setFormData(prev => ({
        ...prev,
        [name]: value
      }));
    }
    
    // Clear error when user starts typing
    if (errors[name]) {
      setErrors(prev => ({
        ...prev,
        [name]: ''
      }));
    }
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.masrafTarihi) {
      newErrors.masrafTarihi = 'Masraf tarihi zorunludur';
    }

    if (!formData.masrafTuru) {
      newErrors.masrafTuru = 'Masraf türü seçimi zorunludur';
    }

    if (!formData.tutar) {
      newErrors.tutar = 'Tutar alanı zorunludur';
    } else if (isNaN(formData.tutar) || parseFloat(formData.tutar) <= 0) {
      newErrors.tutar = 'Geçerli bir tutar giriniz';
    }

    if (!formData.aciklama.trim()) {
      newErrors.aciklama = 'Açıklama alanı zorunludur';
    }

    // File validation
    if (formData.fatura) {
      const allowedTypes = ['image/jpeg', 'image/png', 'application/pdf'];
      const maxSize = 5 * 1024 * 1024; // 5MB
      
      if (!allowedTypes.includes(formData.fatura.type)) {
        newErrors.fatura = 'Sadece JPG, PNG ve PDF dosyaları kabul edilir';
      } else if (formData.fatura.size > maxSize) {
        newErrors.fatura = 'Dosya boyutu 5MB\'dan küçük olmalıdır';
      }
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    if (validateForm()) {
      console.log('Form gönderiliyor:', formData);
      // Here you would typically send the data to your backend
      alert('Masraf bildiriminiz başarıyla gönderildi!');
      
      // Reset form
      setFormData({
        masrafTarihi: '',
        masrafTuru: '',
        tutar: '',
        aciklama: '',
        fatura: null
      });
      
      // Reset file input
      document.getElementById('fatura').value = '';
    }
  };

  const formatCurrency = (value) => {
    if (!value) return '';
    return new Intl.NumberFormat('tr-TR', {
      style: 'currency',
      currency: 'TRY'
    }).format(value);
  };

  return (
    <div className="box">
      <div className="box-header">
        <h4 className="card-title">Masraf Bildirim Formu</h4>
        <p className="text-muted">İş ile ilgili masraflarınızı bildirmek için formu doldurun</p>
      </div>
      <div className="box-body">
        <form onSubmit={handleSubmit}>
          <div className="row">
            <div className="col-md-6 mb-3">
              <label htmlFor="masrafTarihi" className="form-label">
                Masraf Tarihi <span className="text-danger">*</span>
              </label>
              <input
                type="date"
                id="masrafTarihi"
                name="masrafTarihi"
                className={`form-control ${errors.masrafTarihi ? 'is-invalid' : ''}`}
                value={formData.masrafTarihi}
                onChange={handleInputChange}
                max={new Date().toISOString().split('T')[0]}
              />
              {errors.masrafTarihi && (
                <div className="invalid-feedback">{errors.masrafTarihi}</div>
              )}
            </div>

            <div className="col-md-6 mb-3">
              <label htmlFor="masrafTuru" className="form-label">
                Masraf Türü <span className="text-danger">*</span>
              </label>
              <select
                id="masrafTuru"
                name="masrafTuru"
                className={`form-select ${errors.masrafTuru ? 'is-invalid' : ''}`}
                value={formData.masrafTuru}
                onChange={handleInputChange}
              >
                <option value="">Masraf türü seçiniz...</option>
                {masrafTurleri.map((tur) => (
                  <option key={tur.value} value={tur.value}>
                    {tur.label}
                  </option>
                ))}
              </select>
              {errors.masrafTuru && (
                <div className="invalid-feedback">{errors.masrafTuru}</div>
              )}
            </div>
          </div>

          <div className="row">
            <div className="col-md-6 mb-3">
              <label htmlFor="tutar" className="form-label">
                Tutar (TL) <span className="text-danger">*</span>
              </label>
              <div className="input-group">
                <span className="input-group-text">₺</span>
                <input
                  type="number"
                  id="tutar"
                  name="tutar"
                  className={`form-control ${errors.tutar ? 'is-invalid' : ''}`}
                  placeholder="0.00"
                  step="0.01"
                  min="0"
                  value={formData.tutar}
                  onChange={handleInputChange}
                />
                {errors.tutar && (
                  <div className="invalid-feedback">{errors.tutar}</div>
                )}
              </div>
              {formData.tutar && (
                <div className="form-text text-success">
                  {formatCurrency(formData.tutar)}
                </div>
              )}
            </div>

            <div className="col-md-6 mb-3">
              <label htmlFor="fatura" className="form-label">
                Fatura/Fiş Ekle
              </label>
              <input
                type="file"
                id="fatura"
                name="fatura"
                className={`form-control ${errors.fatura ? 'is-invalid' : ''}`}
                accept=".jpg,.jpeg,.png,.pdf"
                onChange={handleInputChange}
              />
              {errors.fatura && (
                <div className="invalid-feedback">{errors.fatura}</div>
              )}
              <div className="form-text">
                JPG, PNG veya PDF formatında, maksimum 5MB
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-12 mb-3">
              <label htmlFor="aciklama" className="form-label">
                Açıklama <span className="text-danger">*</span>
              </label>
              <textarea
                id="aciklama"
                name="aciklama"
                className={`form-control ${errors.aciklama ? 'is-invalid' : ''}`}
                rows="4"
                placeholder="Masrafın detaylarını açıklayın (nerede, ne için harcandığı vs.)..."
                value={formData.aciklama}
                onChange={handleInputChange}
              ></textarea>
              {errors.aciklama && (
                <div className="invalid-feedback">{errors.aciklama}</div>
              )}
              <div className="form-text">
                {formData.aciklama.length}/300 karakter
              </div>
            </div>
          </div>

          {/* Preview uploaded file */}
          {formData.fatura && (
            <div className="row">
              <div className="col-12 mb-3">
                <div className="alert alert-info">
                  <div className="d-flex align-items-center">
                    <i className="bx bx-file me-2"></i>
                    <div>
                      <strong>Yüklenen Dosya:</strong><br />
                      <small>{formData.fatura.name} ({(formData.fatura.size / 1024 / 1024).toFixed(2)} MB)</small>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

          <div className="row">
            <div className="col-12">
              <div className="d-flex justify-content-between">
                <button type="button" className="btn btn-secondary">
                  <i className="bx bx-x me-1"></i>
                  İptal
                </button>
                <button type="submit" className="btn btn-primary">
                  <i className="bx bx-send me-1"></i>
                  Masraf Bildirimi Gönder
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default MasrafBildirimFormu; 